import React from 'react';
import ImageUpload from '../ImageUpload';

const Section8Contact = ({ formData, handleChange, handleFileChange }) => {
  return (
    <div className="fade-in">
      <h4 className="fw-bold mb-4 text-center">📞 Contact Information & Photo</h4>

      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Contact Number *</label>
          <input
            type="tel"
            className="form-control"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
            placeholder="Your phone number"
            required
          />
        </div>

        <div className="col-md-6">
          <label className="form-label">Email Address *</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="your.email@example.com"
            required
          />
        </div>

        {/* NEW IMAGE UPLOAD COMPONENT */}
        <div className="col-12 mt-4">
          <ImageUpload
            onImageSelect={handleFileChange}
            currentImage={formData.profilePhotoUrl}
            maxSizeMB={5}
            circular={true}
            label="Profile Photo *"
            acceptedFormats={['image/jpeg', 'image/png', 'image/jpg', 'image/webp']}
          />
          <small className="text-muted d-block mt-2">
            Upload a clear, recent photo. This helps build trust in the community.
          </small>
        </div>
      </div>
    </div>
  );
};

export default Section8Contact;